<template>
  <BaseDialog centered contentClass="edit-tenant-name" ref="dialog" persistent :show-actions="true">
    <template slot="title">
      {{ this.$t('page.admin-tenants.edit-tenant-name') }}
    </template>
    <template slot="content">
      <form :name="formName" @click.prevent>
        <div>
          <template>
            <FormLabel>{{ $t('page.admin-tenant.edit-name') }}</FormLabel>
            <FormInput id="tenant-name" v-model="name" type="text" ref="tenantName" hasGrayBackground />
          </template>
        </div>

        <div class="base-dialog__edit-tenant--actions">
          <FormButton is-outlined @click.native="cancelClick">
            {{ $t('actions.cancel') }}
          </FormButton>

          <FormButton @click.native="onSubmit">
            <span>{{ $t('dialog.filters.advanced.apply') }}</span>
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import FormLabel from '@/components/form/FormLabel.vue';
import BaseDialog from '@/components/base/BaseDialog.vue';
import FormButton from '@/components/form/FormButton.vue';
import FormInput from '@/components/form/FormInput.vue';

export default {
  name: 'EditTenantName',
  components: {
    BaseDialog,
    FormButton,
    FormInput,
    FormLabel,
  },
  data() {
    return {
      name: '',
    };
  },
  props: {
    formName: {
      type: String,
      default: 'editTenantForm',
    },
  },
  methods: {
    openDialog(tenant) {
      this.name = tenant.name;
      this.$refs.dialog.openModal();

      this.$nextTick(() => {
        const refInput = this.$refs.tenantName.$el.querySelector('input');
        if (refInput) {
          this.$nextTick(() => {
            refInput.focus();
          });
        }
      });
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },

    cancelClick() {
      this.closeDialog();
    },
    onSubmit() {
      this.$emit('update-name', this.name);
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.base-dialog__edit-tenant-name {
  height: auto;
  width: 550px;
  position: relative;

  &.description-mode {
    width: 800px;
  }
  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    background: $color-white !important;
  }

  &--actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
    gap: 12px;
  }

  .form-input {
    padding: 4px 0 24px 0;
  }
}
</style>
